import { useEffect, useState } from "react";

export function RoleRotor({ words, interval = 1800 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((v) => (v + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words.length, interval]);

  return (
    <span className="rotor" style={{ minWidth: "8ch" }} aria-live="polite">
      <span className="rotor-stack" style={{ transform: `translateY(-${index}em)` }}>
        {words.map((word) => (
          <span key={word}>{word}</span>
        ))}
      </span>
    </span>
  );
}
